module.exports = __webpack_public_path__ + "img/tilt_up.0ad09e6d.svg";